import {ENABLE_MERIE_REPORTS, ENABLE_PH_REC} from '@wallaby-ui/core';

export default {
  appName: 'MERIE',
  index: '/hospitalizedPatients',
  loadingComponent: 'LoadingSpinnerPage',
  notFoundComponent: 'NotFoundComponentBox',
  staticGroups: [
    {
      id: 'general',
      label: 'navigation.section.merie',
    },
    {
      id: 'reports',
      label: 'navigation.section.meriereports',
    },
  ],
  staticRoutes: [
    {
      path: '/hospitalizedPatients',
      component: 'HospitalizedPatientsLayout',
      label: 'navigation.route.hospitalizedPatients',
      iconName: 'merieHospitalizationsIcon',
      group: 'general',
    },
    ...(ENABLE_MERIE_REPORTS
      ? [
          {
            path: '/hospitalNetworkReport',
            component: 'MerieHospitalNetworkReportLayout',
            label: 'navigation.route.hospitalNetworkReportMerie',
            iconName: 'haidiHospitalGroupReportIcon',
            group: 'reports',
            roles: ['DEPARTMENT:MULTI_HOSPITAL'],
          },
          {
            path: '/hospitalReport',
            component: 'MerieHospitalReportLayout',
            label: 'navigation.route.hospitalReportMerie',
            iconName: 'haidiHospitalReportIcon',
            group: 'reports',
          },
          {
            path: '/departmentReport',
            component: 'MerieDepartmentReportLayout',
            label: 'navigation.route.departmentReportMerie',
            iconName: 'analytics1',
            group: 'reports',
          },
          {
            path: '/uzisReport',
            component: 'MerieUzisReportLayout',
            label: 'navigation.route.uzisReportMerie',
            iconName: 'analytics2',
            group: 'reports',
            instanceLocations: ['CZ'],
          },
        ]
      : []),
    ...(ENABLE_PH_REC
      ? [
          {
            path: '/pharmacotherapyRecommendationList',
            component: 'PhRecommendationListLayout',
            label: 'navigation.route.pharmacotherapyRecommendationList',
            iconName: 'haidiHaiListIcon',
            group: 'general',
          },
        ]
      : []),
    {
      path: '/settings',
      component: 'SettingsLayoutContainer',
      label: 'navigation.routeGroup.userSettings',
      hidden: true,
    },
    {
      path: '/hospitalizedPatientsByHospSrcId',
      component: 'HospitalizedPatientsByHospSrcIdContainer',
      label: 'navigation.routeGroup.hospitalizedPatientsByHospSrcId',
      paramsString: '/:hospitalizationSrcId',
      hidden: true,
    },
  ],
  dynamicRoutes: [
    {
      id: 'patient',
      path: '/hospitalizedPatients',
      paramsString: '/:hospitalizationId/document?/:documentId?',
      component: 'HospitalizationDetailLayoutContainer',
      iconClass: 'fa-user',
      label: '?',
      redirectOnCloseRoute: '/hospitalizedPatients',
    },
    {
      id: 'hospitalizedPatientV2',
      path: '/hospitalizedPatients/v2',
      paramsString: '/:hospitalizationId/document?/:documentId?',
      component: 'HospitalizationDetailLayoutV2',
      iconClass: 'fa-user',
      label: '?',
      redirectOnCloseRoute: '/hospitalizedPatients',
    },
  ],
  dynamicGroups: [
    {
      ids: ['patient', 'hospitalizedPatientV2'],
      label: 'navigation.routeGroup.openedCases',
    },
  ],
};
